import { createSvgComponent } from "../../icon/createSvgComponent";
import Coupon from "@core/icon/assets/coupon.svg";
export default createSvgComponent(Coupon);